import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import BaseIconComponent from 'components/SongActionButtons/components/BaseIconComponent';
import { remixerApi } from 'services/api/remixer';
import ConfirmDeletionModal from 'pages/Library/components/ConfirmDeletionModal';

const DeleteButton = ({ projectId }: { projectId: string }) => {
  const { t } = useTranslation();
  const [isConfirmDeletionModalOpen, setIsConfirmDeletionModalOpen] =
    useState(false);
  const openModal = () => setIsConfirmDeletionModalOpen(true);
  const closeModal = () => setIsConfirmDeletionModalOpen(false);

  const [deleteProject] = remixerApi.useDeleteProjectMutation();

  const handleDelete = () => {
    deleteProject(projectId);
    closeModal();
  };

  return (
    <>
      <BaseIconComponent
        title={t('library:projects:deleteProject')}
        icon={<DeleteIcon />}
        onClick={openModal}
      />
      <ConfirmDeletionModal
        title={t('library:confirmDeletionModal:title:deleteProject')}
        description={t('library:confirmDeletionModal:description:project')}
        isOpen={isConfirmDeletionModalOpen}
        onClose={closeModal}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default DeleteButton;
